import { Nullable } from "@core/domain/types/nullable.type";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { ContractsRepository } from "@entity/data/repositories/contracts.repository";
import { CreateFreelanceContract } from "@entity/domain/models/employee/contracts/freelance/create-freelance-contract.model";
import { FreelanceContract } from "@entity/domain/models/employee/contracts/freelance/freelance-contract.model";
import { inject, injectable } from "inversify";

@injectable()
export class CreateFreelanceContractUseCase {
    constructor(
        @inject(ContractsRepository)
        private readonly contractsRepository: ContractsRepository,
    ) {}

    async execute(
        freelanceContract: CreateFreelanceContract,
    ): Promise<Nullable<FreelanceContract>> {
        const creationResult =
            await this.contractsRepository.createFreelanceContract(
                freelanceContract,
            );

        if (creationResult.isLeft()) {
            ToastManagerStore.error(creationResult.getLeftOrThrow().message);
        }

        return creationResult.fold(
            () => null,
            (createdFreelanceContract) => createdFreelanceContract,
        );
    }
}
